"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerBody = void 0;
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
exports.ContainerBody = (0, styled_components_1.default)(antd_1.Row) `
  padding: 0 5% 10% 5%;
  margin-top: 117px;
  max-width: 1980px;
  min-height: 100vh;
  height: auto;
  position: relative;
  @media screen and (max-width: 1600px) {
    padding: 0 2%;
  }
`;
